import { Component, OnInit, Input } from '@angular/core';
import { HttpService } from '../../services/http/http.service';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from '../../util/helper/helper.service';
import * as moment from 'moment';
import { orderBy } from "lodash";

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.scss']
})
export class WorkflowComponent implements OnInit {
  bgColors = {
    received: '#F44336',
    requested: '#4CAF50',
    accepted: '#9E9E9E'
  }

  @Input() patientId;
  @Input() patientDetails: any = {};
  isSkeleton = false;
  taskHistory = [];
  fakeData = [1,2,3,4,5];
  nextPageUrl = '';
  
  constructor(private httpService: HttpService,
    private toastr: ToastrService,
    private helper: HelperService) { }

  ngOnInit(): void {
    this.getTaskHistory();
  }

  getTaskHistory(){
    this.isSkeleton = true;

    const payload:any = {
      patientId: this.patientId,
      count: 10
    };
    if(this.nextPageUrl)
      payload.nextUrl = this.nextPageUrl;
  
    this.httpService.post(`task/audit`, payload)
      .subscribe((response: any) => {
        let tasks = response.tasks;
        tasks = orderBy(tasks, x => x.task.status==='requested', 'desc')
        tasks.length&&tasks.map(x=>{
          x.actor = this.helper.formatPatientData(x.requester);

          if(x.task.status === 'accepted'){
            x.status = 'Moved';
            x.timeInQueue = this.getTimeInQueue(x.task.meta.lastUpdated, x.task.authoredOn);
          }else if(x.task.status === 'requested'){
            x.status = 'Active';
            x.timeInQueue = this.getTimeInQueue(moment(), x.task.authoredOn);
          }else if(x.task.status === 'received'){
            x.status = 'Archived';
            x.timeInQueue = this.getTimeInQueue(x.task.meta.lastUpdated, x.task.authoredOn);
          }
        })
        this.taskHistory = [...this.taskHistory ,...tasks];
        this.nextPageUrl = response.nextUrl || '';
        this.isSkeleton = false;
      }, error => {
        this.isSkeleton = false;
        this.toastr.warning(error, 'Patients', {
          progressBar: true, timeOut: 3000
        });
      })
  }

  getTimeInQueue(date1, date2){
    const startDate = moment(date1)
    const endDate = moment(date2)
    const time = startDate.diff(endDate, 'seconds');
    return this.helper.getDuration(time);
  }

  getDisplayDate(date) {
    return moment(date).fromNow();
  }

  onScroll(){
    if(this.nextPageUrl)
      this.getTaskHistory()
  }
}
